export default "__VITE_ASSET__5df07c10__"